module.exports = __webpack_public_path__ + "img/dashboard.2a2b1973.jpeg";